import { useEffect, useState } from 'react';

// based on https://usehooks.com/useDebounce/
export default function useDebounce<Value>(value: Value, msDelay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, msDelay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, msDelay]);
  return debouncedValue;
}
